import React from 'react';
import ToggleButton from "../ToggleButton";
import Picture from "../Picture";
import { formatImageUrl } from "../../utils";

function Sponsor({ openInNewTab, accessibleText, url, templateUrl, displayText, hasPresBy }) {
  const { highQuality } = templateUrl ? formatImageUrl(templateUrl, { format: "w_175,c_scale", extension: "f_png" }) : {};

  return (
    highQuality ? (
      (url) ? (<ToggleButton
        target={`${openInNewTab ? "_blank" : "_self"}`}
        rel={`${openInNewTab ? "noopener noreferrer" : ""}`}
        alt={`${accessibleText ? accessibleText : ""}`}
        href={url} className="mls-o-sponsor">
        {
          hasPresBy
            ? <div className="mls-o-sponsor__label">{displayText ? displayText : "Presented By"}</div>
            : null
        }
        <Picture src={highQuality} title="sponsor" loadingSrc={null} fallbackSrc={null} extraClasses="mls-o-sponsor__image" />
      </ToggleButton>)
        :
        (<span className="mls-o-sponsor">
          {
            hasPresBy
              ? <div className="mls-o-sponsor__label">{displayText ? displayText : "Presented By"}</div>
              : null
          }
          <Picture src={highQuality} title="sponsor" loadingSrc={null} fallbackSrc={null} extraClasses="mls-o-sponsor__image" />
        </span>)
    ) : null
  );
}

export default Sponsor;
